"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Refs = /** @class */ (function () {
    function Refs() {
        this.root = null;
        this.handle = null;
    }
    return Refs;
}());
exports.default = Refs;
//# sourceMappingURL=Refs.js.map